<script>
  import { getContext } from "svelte";
  import {
    HERO_COMPONENT_MAP,
    getHeroVariantProps,
    HERO_VARIANTS_WITH_THEME
  } from "$lib/utilities/contentTypes/hero";
  import Hero from "$lib/components/Hero.svelte";
  import { heroThemeStore } from "$lib/stores";

  export let data;

  let formFactor = data.fields.formFactor;

  const component = HERO_COMPONENT_MAP[formFactor];

  const pageDataContext = getContext("pageData");

  let heroProps = getHeroVariantProps(data.fields, pageDataContext);

  let hasThemedBackground = HERO_VARIANTS_WITH_THEME.includes(formFactor);

  if (hasThemedBackground) {
    // Used to update the the Global Navigation background color based on current Home Hero background color
    heroThemeStore.set(heroProps?.theme ?? "white");
  } else {
    heroThemeStore.set("white");
  }
</script>

<Hero data={heroProps} {component} />
